import { NavLink } from 'react-router-dom';
import { useNavigate } from "react-router";
import PropTypes from 'prop-types'; 
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography'; 
import { toast } from "react-toastify";
import { fCurrency } from '../utils/format-number'; 
import Label from './label';
import { ColorPreview } from './color-utils';
import shortenAddress from '../utils/shortenAddress';

export default function NftCard({ chainid,nft }) {
   //  console.log('NftCard nft:',nft)
  const navigate = useNavigate();  
  const handleSetClick = () => { 
      navigate("/setnftv2/"+chainid+"&"+nft?.contract+"&"+nft?.tokenId, { replace: true });     
  };  
  const handleEditClick = () => { 
      navigate("/editnftv2/"+chainid+"&"+nft?.contract+"&"+nft?.tokenId, { replace: true });    
       
  };  
  const nftdetailClick = () => {
    navigate("/assets/"+chainid+"&"+nft?.contract+"&"+nft?.tokenId, { replace: true });
  }
  const renderStatus = (
    <Label
      variant="filled"
      color={(nft.tokenType === 'ERC1155' && 'error') || 'info'}
      sx={{
        zIndex: 9,
        top: 16,
        right: 16,
        position: 'absolute',
        textTransform: 'uppercase',
      }}
    >
      {nft.tokenType}
    </Label>
  );

  const renderImg = ( 
    <Box
      component="img"
      alt={nft.name}
      src={nft.media}
      sx={{
        top: 0,
        width: 1,
        height: 1,
        objectFit: 'cover',
        position: 'absolute',
      }}
    />
  );

  const rendercollectionName = (
    <Typography variant="subtitle1">
      <Typography
        component="span"
        variant="body1"
        sx={{
          color: 'text.disabled', 
        }}
      >
      {nft.collectionName &&
        nft.collectionName.length > 20
          ? `${nft.collectionName.substring(0, 20)}`
          : nft.collectionName}
      </Typography>
      &nbsp; {shortenAddress(nft.contract)} #{nft.tokenId.substring(0,8)}
    </Typography>
  );

  return (
    <Card   >
      <NavLink  to={{pathname: `/assets/${chainid}&${nft.contract}&${nft.tokenId}`,}}>
        <Box sx={{ pt: '100%', position: 'relative' }}>
          {nft.tokenType && renderStatus} 
          {renderImg}
        </Box>
      </NavLink>
      <Stack spacing={2} sx={{ p: 3 }}>
        <Typography color="inherit"   variant="subtitle2" noWrap>
        {nft.title ? nft.tile?.length > 20
							? `${nft.title.substring(0, 12)}...`
							: nft.title : `${nft.symbol} ${nft.tokenId.substring(0,4)}`}
        </Typography>

        <Stack direction="row" alignItems="center" justifyContent="space-between">
         {/*  <ColorPreview colors={nft.colors} /> */}
          {rendercollectionName}
        </Stack>
      </Stack>
      <CardActions>
        <Button variant="contained" size="small" onClick={handleEditClick}>Edit</Button>
       
       <Button variant="contained"  size="small" onClick={handleSetClick}>Setting</Button>  
      
        <Button variant="contained" size="small" onClick={nftdetailClick}>Detail</Button>
      </CardActions> 
    </Card>
  );
}

NftCard.propTypes = {
  nft: PropTypes.object,
};
